import { createAsyncAction } from 'typesafe-actions';
import ActionTypes from './constants';

export const contactUs = createAsyncAction(
  ActionTypes.CONTACT_US_SUBMIT,
  ActionTypes.CONTACT_US_SUCCESS,
  ActionTypes.CONTACT_US_FAILURE,
)<any, void, Error>();
